<template>
  <v-app>
    <Appbar v-if="appBar" @on-logout="onLogout" />

    <v-main>
      <v-fade-transition>
        <router-view></router-view>
      </v-fade-transition>
      <ModalLoading v-model="loading" />
      <Snackbar v-model="snackbar.value" :text="snackbar.text" :color="snackbar.color" @close="hideMessage" />
    </v-main>
    <FooterMenu v-if="footerMenu" />
  </v-app>
</template>

<script>
import authenticationService from '@/services/authentication'
import { mapState, mapActions, mapGetters } from 'vuex'
import ModalLoading from '@/core/components/ModalLoading'
import Snackbar from '@/core/components/Snackbar'
import Appbar from '@/core/components/Appbar'
import FooterMenu from '@/core/components/FooterMenu'

export default {
  components: {
    ModalLoading,
    Snackbar,
    Appbar,
    FooterMenu
  },
  name: 'App',
  computed: {
    ...mapState('app', ['loading', 'snackbar']),
    ...mapGetters('user', ['user']),
    isAuthenticated() {
      return authenticationService.isAuthenticated()
    },
    appBar() {
      return this.$route.meta.appBar
    },
    footerMenu() {
      return this.$route.meta.footerMenu
    }
  },
  methods: {
    ...mapActions('app', ['hideMessage']),
    ...mapActions('user', ['logoutUser']),
    setDatadogUser() {
      const user = this.$getDatadogUser()
      if (this.isAuthenticated && !user) {
        this.$setDatadogUser(this.user.id, this.user.nome, this.user.email)
      }
    },
    onLogout() {
      authenticationService.logout()
      this.$logoutDatadogUser()
      this.logoutUser()
      this.$router.push({ name: 'Login' })
    }
  },
  mounted() {
    this.$initDatadog()
    this.setDatadogUser()
  }
}
</script>
